export default __webpack_public_path__ + "static/media/bice-vida-checkout.dbd6c3b1.png";